var map = {
	"./icon-email-blue.png": "c6c4",
	"./icon-email.png": "2c8e",
	"./icon-facebook-blue.png": "db9f",
	"./icon-facebook.png": "39a5",
	"./icon-line-blue.png": "a71e",
	"./icon-line.png": "a7dd",
	"./icon-phone-blue.png": "8e58",
	"./icon-work-01.png": "1094",
	"./icon-work-02.png": "0b0e",
	"./icon-work-03.png": "e009",
	"./icon-work-04.png": "738c",
	"./icon-work-05.png": "c8db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8cba";